import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { ApplicationListItem } from '../../interfaces/application-list-item';
import * as ApplicationActions from './applications.actions';

export const applicationsFeatureKey = 'applications';

export interface State extends EntityState<ApplicationListItem> {
  // additional entities state properties
  loading: boolean;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
  error: any;
}

export const adapter: EntityAdapter<ApplicationListItem> =
  createEntityAdapter<ApplicationListItem>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loading: false,
  creating: false,
  updating: false,
  deleting: false,
  error: null,
});

export const applicationsReducer = createReducer(
  initialState,
  on(ApplicationActions.loadApplications, (state) => ({ ...state, loading: true })),
  on(ApplicationActions.loadApplicationsSuccess, (state, action) =>
    adapter.upsertMany(action.applications, { ...state, loading: false })
  ),
  on(ApplicationActions.loadApplicationsFailure, (state, action) => ({
    ...state,
    error: action.error,
    loading: false,
  })),
  on(ApplicationActions.createApplication, (state, action) => ({ action, ...state, creating: true })),
  on(ApplicationActions.createApplicationSuccess, (state, action) =>
    adapter.upsertOne(action.application, { ...state, creating: false })
  ),
  on(ApplicationActions.createApplicationFailure, (state, action) => ({
    ...state,
    error: action.error,
    creating: false,
  })),
  on(ApplicationActions.updateApplication, (state, action) => ({ action, ...state, updating: true })),
  on(ApplicationActions.updateApplicationSuccess, (state, action) =>
    adapter.upsertOne(action.application, { ...state, updating: false })
  ),
  on(ApplicationActions.updateApplicationFailure, (state, action) => ({
    ...state,
    error: action.error,
    updating: false,
  })),
  on(ApplicationActions.deleteApplication, (state) => ({ ...state, deleting: true })),
  on(ApplicationActions.deleteApplicationSuccess, (state, action) =>
    adapter.removeOne(action.id, { ...state, deleting: true })
  ),
  on(ApplicationActions.deleteApplicationFailure, (state, action) => ({
    ...state,
    error: action.error,
    deleting: true,
  })),
  on(ApplicationActions.clearApplications, (state) => adapter.removeAll(state))
);

export const selectApplicationState = createFeatureSelector<State>(applicationsFeatureKey);

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors(selectApplicationState);

export const selectApplicationsAll = selectAll;
export const selectApplicationsTotal = selectTotal;
export const selectApplicationsEntities = selectEntities;
export const selectApplicationsIds = selectIds;

export const selectApplicationsLoading = createSelector(selectApplicationState, (state) => state.loading);
